export default __webpack_public_path__ + "static/media/carc.f54b5ed7.png";